import i18n from '@/i18n'

const { t } = i18n.global

const isDEV = process.env.NODE_ENV === 'development' || !true
const isPRD = process.env.NODE_ENV === 'production' || true
const isTMP = !true //temporary use
const isLBE = !true //local custom api

/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
const utmCpntsArr = [
  { type: 'landing-page', name: 'utmModal.landing', abbr: 'lp', apip: 'URL' },
  { type: 'utm-source', name: 'UTM SOURCE', abbr: 'cs', apip: 'UtmSource' },
  { type: 'utm-medium', name: 'UTM MEDIUM', abbr: 'cm', apip: 'UTMMedium' },
  { type: 'utm-term', name: 'UTM TERM', abbr: 'ct', apip: 'UTMTerm' },
  { type: 'utm-campaign', name: 'UTM CAMPAIGN', abbr: 'cn', apip: 'UTMCampaign' },
  { type: 'utm-campaign-items', name: 'UTM CAMPAIGN ITEMS', abbr: 'cn-d', apip: 'utm_campaign_items' },
  { type: 'utm-content-items', name: 'UTM CONTENT ITEMS', abbr: 'cc-d', apip: 'utm_content_items' },
  { type: 'utm-content', name: 'UTM CONTENT', abbr: 'cc', apip: 'UTMContent' },
  { type: 'country-site', name: 'Country Site', abbr: 'cn-cs', apip: 'CountrySite' },
  { type: 'campaign-phrase', name: 'Campaign Phase', abbr: 'cn-cp', apip: 'CampaignPhase' },
  { type: 'product-name', name: 'Product Name', abbr: 'cn-pn', apip: 'ProductName' },
  { type: 'audience-target', name: 'Audience Target', abbr: 'cn-at', apip: 'AudienceTarget' },
  { type: 'ad-type', name: 'Ad Type', abbr: 'cc-at', apip: 'AdType' },
  { type: 'creative', name: 'Creative', abbr: 'cc-cr', apip: 'Creative' },
  { type: 'affinity', name: 'Affinity', abbr: 'cc-af', apip: 'Affinity' },
  { type: 'age', name: 'Age', abbr: 'cc-ag', apip: 'Age' },
]
const utmCpntsObj = utmCpntsArr.reduce(
  (obj, item) => ((obj[item.abbr] = { type: item.type, name: item.name, apip: item.apip }), obj),
  {},
)
const utmCpntTypes = utmCpntsArr.filter((e) => e.apip).map((e) => e.abbr)

export { isDEV, isPRD, isTMP, isLBE, utmCpntsArr, utmCpntsObj, utmCpntTypes }
